// IMPORTS
// Assets
import BarGauge from './BarGauge';


// COMPONENT
export default function UsageByLocation (props) {
   // Component
   return (
      <div className='oneport-dashboard-usagebylocation oneport-dashboard-bargraph'>
         {props.parent.usageByLocation && props.parent.usageByLocation.length > 0 && props.parent.usageByLocation.map(function (item, i) {
            return (
               <BarGauge key={`oneport-dashboard-usagebylocation-${i}`} title={item.location} current={item.current} max={item.max} />
            );
         })}
      </div>
   );
}